import datalayerActions from './datalayer-actions';

/**
 * Notification box used on vehicle page with reservations and financing applications.
 */
class NotificationComponent {
  /**
   * Constructor
   * @param {HTMLElement} elem Notification component's root element
   */
  constructor(elem) {
    this.component = elem;
    this.closeButtons = elem.querySelectorAll('.notification-component__close');

    this.addCloseButtonListeners();
    this.handleAnalytics();
  }
  /**
   * Add event listeners for close buttons
   */
  addCloseButtonListeners() {
    this.closeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        this.component.remove();
      })
    })
  }

  /**
   * Handle element's analytics.
   */
  handleAnalytics() {

    const analyticsEventName = this.component.dataset.analyticsEventName;
    if (this.component.dataset.analyticsEventName) {

      datalayerActions.pushObjectToDatalayer({
        event: this.component.dataset.analyticsEventName || 'GAEvent',
        eventCategory: this.component.dataset.analyticsEventCategory || 'Reporting',
        eventAction: this.component.dataset.analyticsEventAction || '',
        eventLabel: this.component.dataset.analyticsEventLabel || '',
        transactionId: this.component.dataset.analyticsTransactionId || '',
      });
    }
  }
}

export default NotificationComponent;
